const JobLogStatus = ({ status }) => {
  const { name, color } = status;

  return <div className={`job-log-status job-log-status--${color}`}>{name}</div>;
};

export default JobLogStatus;
